import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { useEffect } from 'react'
import { ModalBody, ModalFooter } from 'reactstrap'
import CustomModal from '../CustomModal'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import '../style.css'
import CancelModalButton from 'components/Custom/CancelModalButton'
import DeleteButton from 'components/Custom/DeleteButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
const EditScorm = (props) => {
  const scormUrl = window.location.href
    ? window.location.href.replace('/edit/', '/')
    : null
  const scorm = props.content.find((item) =>
    item.id === parseInt(props.match.params.id) ? item : null
  )
  const copyScormUrl = () => {
    const urlclipboard = scormUrl
    return navigator.clipboard
      .writeText(urlclipboard)
      .then(() => {
        toast.info(
          <div>
            The scorm url: <br /> "{urlclipboard}" was copied successfully
          </div>,
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'toast-message-smaller',
            autoClose: 3000,
          }
        )
      })
      .catch(() => {
        toast.error('Failed to copy url, please try again', {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: 'toast-message-smaller',
          autoClose: 3000,
        })
      })
  }

  let language = props.language || {}

  return (
    <>
      <ModalBody>
        <div className='row'>
          <div className='col-md-6 '>
            <div className='upload-video-form-row'>
              <label>
                {language.settings ? language.settings.title : null}:{' '}
              </label>
              <input
                type='text'
                name='title'
                autoFocus
                value={props.title ? props.title : ''}
                onChange={(event) =>
                  props.onChangeTitleText(event.target.value)
                }
              />
            </div>
          </div>
          <div className='col-md-6  '>
            <div className='upload-scorm-form-row'>
              <label>Scorm Url:</label>
              <input type='text' name='scorm url' value={scormUrl} disabled />
              <a
                style={{ cursor: 'pointer' }}
                onClick={copyScormUrl}
                title={`Copy scorm url: ${scormUrl}`}
              >
                <FontAwesomeIcon
                  icon={faCopy}
                  className=' far scorm-input ml-2'
                />
              </a>
            </div>
          </div>
        </div>

        <div className='custom-control custom-checkbox-info mt-2'>
          <input
            className='custom-control-input'
            id='required_content'
            type='checkbox'
            checked={scorm ? scorm.required : false}
            onChange={() => props.setContentRequired(scorm.id)}
          />
          <label
            className='custom-control-label '
            htmlFor='required_content'
            style={{ fontSize: '14px', paddingTop: '2px' }}
          >
            {language?.courses?.required}
          </label>
        </div>
      </ModalBody>

      <ModalFooter className='d-flex justify-content-start mt-3'>
        <Link to={`/course/${props.id}/edit`}>
          <SubmitModalButton
            text={language.general ? language.general.submit : null}
            customFn={() => props.updateScormContent(scorm.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <DeleteButton
            text={language.general ? language.general.delete : null}
            customFn={() => props.deleteContent(scorm.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <CancelModalButton
            text={language.general ? language.general.cancel : null}
          />
        </Link>
      </ModalFooter>
    </>
  )
}

export default function ManageScorm(props) {
  useEffect(() => {
    props.fetchTextContent(props.match.params.id)
  }, [])
  return (
    <CustomModal courseId={props.course_id} title='Edit Scorm' size='lg'>
      <EditScorm {...props} />
    </CustomModal>
  )
}
